import { formatEuros } from './getEuros';

const getTotalCost = (calculatedCost: number, alv: number) => {
  const total = calculatedCost * (alv * 0.01);
  return formatEuros(total);
}

export default getTotalCost;
